export class AssistanceApplicationAuditType {
    public static readonly None = 'None';
    public static readonly ReviewAndAudit = 'ReviewAndAudit';
    public static readonly AgencyReview = 'AgencyReview';
}
